import { DraggableMarker, StreamEl, theme } from '@mi-front/ui';
import { useCursor, useSetCursor } from '../../../stores/stream-screen.store';
import { CursorMenu } from './cursor-menu/CursorMenu';

interface Props {
  readonly ts: number;
  readonly onChange: (ts: number) => void;
}

export function CursorP(p: Props) {
  return (
    <>
      <DraggableMarker ts={p.ts} color={theme.aqua} onChange={p.onChange} />
      <StreamEl ts={p.ts} position="center" offsetX={-32} offsetY={-70} zIndex={100} checkOverflow>
        <CursorMenu />
        <span data-cursor-ts={p.ts} style={{ display: 'none' }} />
      </StreamEl>
    </>
  );
}

export function Cursor() {
  const ts = useCursor();
  const setCursor = useSetCursor();

  if (!ts) {
    return null;
  }

  return <CursorP ts={ts} onChange={setCursor} />;
}
